import { Component, OnInit } from '@angular/core';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';

@Component({
  selector: 'app-token-expired',
  templateUrl: './token-expired.component.html',
  styleUrls: ['./token-expired.component.css']
})
export class TokenExpiredComponent implements OnInit {

  constructor(private userService: UsuarioService) { }

  ngOnInit(): void {
  }

  irLogin(){
    this.userService.clearLocalStorage();
    setTimeout(() => {
      window.location.href = "/";
    }, 200);
  }
}
